import React from "react";
import {
  Box,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { green, grey, orange, red } from "@mui/material/colors";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { DateTime } from "luxon";
import IncomeStatsCard from "../../income/IncomeStatsCard.component";
import { getTimeZoneStandard } from "utils/timezone";
import StatsCardWrapper from "./StatsCardWrapper.component";
import ReportProblemTwoToneIcon from "@mui/icons-material/ReportProblemTwoTone";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import ErrorTwoToneIcon from "@mui/icons-material/ErrorTwoTone";
import HelpTwoToneIcon from '@mui/icons-material/HelpTwoTone';
const StatsCardComponent = (props) => {
  const {
    title,
    type,
    primaryColor,
    labelCenter,
    valueCenter,
    contentBottom,
    labelBottom,
    time,
    isloading,
    comulativeDays,
    comulativeDaysStatus,
    onClickCard = () => { },
  } = props;
  const theme = useTheme();
  const { t, i18n } = useTranslation();

  return isloading ? (
    <IncomeStatsCard />
  ) : (
    <StatsCardWrapper
      onClick={onClickCard}
      border={false}
      content={false}
      avatarcolor={primaryColor}
      sx={{ cursor: "pointer" }}
    >
      <Grid container alignItems="start" height={100}>
        <Grid
          item
          xs={3}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 100,
            height: 100,
          }}
        >
          {type ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {type === "critic" ? (
                <ErrorTwoToneIcon
                  style={{
                    color: red[500],
                    width: 35,
                    height: 35,
                    zIndex: 20,
                  }}
                />
              ) : type === "warning" ? (
                <ReportProblemTwoToneIcon
                  style={{
                    color: orange[500],
                    width: 35,
                    height: 35,
                    zIndex: 20,
                  }}
                />
              ) : (
                <CheckCircleTwoToneIcon
                  style={{
                    color: green[600],
                    width: 35,
                    height: 35,
                    zIndex: 20,
                  }}
                />
              )}
            </Box>
          )
        :
        <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
       <HelpTwoToneIcon 
        style={{
          color: grey[600],
          width: 35,
          height: 35,
          zIndex: 20,
        }}/> 
        </Box>}
        </Grid>
        <Grid item container xs={9} pt={1} pr={1} pl={1}>
          <Grid
            item
            container
            xs={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              item
              xs={12}
              display="flex"
              alignItems="center"
              justifyContent="center"
              sx={{ position: "relative" }}
            >
              <Typography
                align="center"
                sx={{
                  fontSize: 13,
                  fontWeight: "bold",
                  color: theme.palette.mode === "dark" ? "#fff" : "black",
                }}
              >
                {title}
              </Typography>

              <Box sx={{ position: "absolute", right: 1, top: 0 }}>
                {time !== null && time !== undefined && (
                  <Tooltip
                    title={
                      time ?
                        `${t("Data relating to")}: ${DateTime.fromISO(
                          getTimeZoneStandard(time)
                        ).toLocaleString(DateTime.DATE_MED, {
                          locale: i18n?.language ? i18n.language : "it",
                        })}` :
                        `${t("Data relating to")}: ${t('unknown')}`}
                  >
                    <IconButton sx={{ padding: 0 }}>
                      <InfoOutlinedIcon
                        style={{
                          width: 15,
                          height: 15,
                          color: theme.palette.grey[700],
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Grid>

          </Grid>

          <Grid
            item
            container
            xs={12}
            display="flex"
            alignItems="center"
            sx={{ minHeight: 50 }}
            mb={0.5}
          >
            <Grid
              item
              container
              xs={comulativeDays !== undefined && comulativeDays !== null ? 10 : 12}
              display="flex"
              alignItems="center"
            >
              <Grid
                item
                xs={comulativeDays !== undefined && comulativeDays !== null ? 10 : 12}
                >
                <Typography
                  align={"center"}
                  variant="h6"
                >
                  {labelCenter}
                  {valueCenter !== undefined && valueCenter !== false && (
                      <Box
                        component={"span"}
                        sx={{
                          display: "inline-block",
                          whiteSpace: "nowrap"
                        }}
                      >
                        &nbsp;{valueCenter}
                      </Box>
                  )}
                </Typography>
              </Grid>
            </Grid>

            {comulativeDays !== null && comulativeDays !== undefined && (
              <Grid item xs={2} display="flex" justifyContent="flex-end">
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                >
                  <Typography
                    align="center"
                    sx={{
                      lineHeight: 1,
                      fontSize: 9,
                      padding: 0,
                      color: theme.palette.grey[700],
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {`${comulativeDays} / 35`}
                  </Typography>
                  <Typography
                    align="center"
                    sx={{
                      lineHeight: 1,
                      fontSize: 9,
                      padding: 0,
                      color: theme.palette.grey[700],
                    }}
                  >
                    {t("Days")}
                  </Typography>
                </Box>

                {comulativeDaysStatus !== undefined &&
                  comulativeDaysStatus !== null && (
                    <Box ml={1} sx={{ fontWeight: "bold" }}>
                      {comulativeDaysStatus === "critic" ? (
                        <ErrorOutlineIcon
                          style={{
                            color: red[500],
                            width: 13,
                            height: 13,
                            zIndex: 20,
                          }}
                        />
                      ) : comulativeDaysStatus === "warning" ? (
                        <WarningAmberIcon
                          style={{
                            color: orange[500],
                            width: 13,
                            height: 13,
                            zIndex: 20,
                          }}
                        />
                      ) : (
                        <CheckCircleOutlineIcon
                          style={{
                            color: green[600],
                            width: 13,
                            height: 13,
                            zIndex: 20,
                          }}
                        />
                      )}
                    </Box>
                  )}
              </Grid>
            )}
          </Grid>

          <Grid
            item
            xs={12}
            display="flex"
            alignItems="center"
            justifyContent="end"
          >
            <Typography
              sx={{
                fontSize: 10,
                color: theme.palette.grey[700],
                whiteSpace: "nowrap",
                align: "right",
                paddingRight: 0.5,
              }}
            >
              {labelBottom}
            </Typography>

            {contentBottom !== null ? (
              <Typography
                variant="h6"
                sx={{
                  fontSize: 11,
                  whiteSpace: "nowrap",
                  alignItems: "flex-end",
                }}
                align="right"
              >
                {contentBottom}
              </Typography>
            ) : (
              <Typography
                sx={{
                  fontSize: 10,
                  color: theme.palette.grey[700],
                  fontWeight: 500,
                }}
              >
                {t("Data not available")}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Grid>
    </StatsCardWrapper>
  );
};

StatsCardComponent.propTypes = {
  title: PropTypes.string,
  days: PropTypes.number,
  type: PropTypes.string,
  hasProgress: PropTypes.bool,
  lastDays: PropTypes.number,
  tot: PropTypes.number,
  primaryColor: PropTypes.string,
};

export default StatsCardComponent;
